import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class PropertyTagRepositoryService extends BaseRepositoryService<
  ModelRegistry['property-tag']
> {
  recordName = 'property-tag';
  implementMethods = ['findAll', 'peekAll', 'peekRecord'];
}

declare module '@ember/service' {
  interface Registry {
    'repositories/property-tag': PropertyTagRepositoryService;
  }
}
